module.exports = __webpack_public_path__ + "static/share-logo-wechat-3e62b0f9faab4e2e20378b2f28c2a4bc.jpg";